import React from 'react'
import img2 from "../assets/images/blog/9.png"
import img3 from "../assets/images/blog/7.png"
import img1 from "../assets/images/blog/4.png"
import { Link } from 'react-router-dom'
import { BiLogoFacebook } from 'react-icons/bi';
import { AiOutlineTwitter } from 'react-icons/ai';
import { BiLogoLinkedin } from 'react-icons/bi';
import { AiOutlineInstagram } from 'react-icons/ai';

export default function HowitsWork() {
    return (
        <div>
            <section className="section bg-gradient-new pricing" id="pricing">
                <div className="bg-shape" />
                <div className="container">
                    <div className="row gy-5 justify-content-center mt-4" >
                        <div className="col-lg-10">
                            <div className="text-center">
                                <p className=" quesb"> Published APRAIL 26, 2023</p>
                                <p className="blogheadingmain">Professional Medical Headshots for Doctor</p>
                                <p className="quesblog">By Kurt Clayson</p>
                            </div>
                        </div>
                    </div>

                    <div className="row gy-5 justify-content-center" >
                        <div className="col-lg-10">
                            <ul className="list-unstyled footer-link d-flex justify-content-center ">
                                <li>
                                    <p className='socialicon'>< BiLogoFacebook color='#fff' size={30} /></p>
                                </li>
                                <li>
                                    <p className='socialicon'>< AiOutlineTwitter color='#fff' size={30} /></p>
                                </li>
                                <li>
                                    <p className='socialicon'>< BiLogoLinkedin color='#fff' size={30} /></p>
                                </li>
                                <li>
                                    <p className='socialicon'>< AiOutlineInstagram color='#fff' size={30} /></p>
                                </li>
                            </ul>
                        </div>
                    </div>


                    {/* End col */}
                    <div className="row gy-5 justify-content-center mt-2">
                        <div className="col-lg-12 ">
                            <div className="p-3 border-secondary h-100 mx-1">
                                <div className=" text-center ">
                                    <img src={img1} alt='' style={{ width: "90%" }} />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-10 ">
                            <div className=" mt-3">
                                <p className="blogpara">Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio at voluptas pariatur, rem tenetur perspiciatis, aut repellendus nesciunt placeat perferendis dolor illum qui. Asperiores id distinctio quasi soluta voluptatem earum ex voluptates nobis a qui consequatur dolor sed debitis, inventore. </p>
                                <p className="blogpara">Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio at voluptas pariatur, rem tenetur perspiciatis, aut repellendus nesciunt placeat perferendis dolor illum qui. Asperiores id distinctio quasi soluta voluptatem earum ex voluptates nobis a qui consequatur dolor sed debitis, inventore, doloribus alias explicabo suscipit nesciunt maxime. Quidem vitae tempora odit in reiciendis quisquam, enim iusto molestiae numquam illo quasi.</p>
                                <p className="blogpara">Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio at voluptas pariatur, rem tenetur perspiciatis, aut repellendus nesciunt placeat perferendis dolor illum qui. Asperiores id distinctio quasi soluta voluptatem earum ex voluptates nobis a qui consequatur dolor sed debitis, inventore, doloribus alias explicabo suscipit nesciunt maxime. Quidem vitae tempora odit in reiciendis quisquam, enim iusto molestiae numquam illo quasi.</p>
                                <p className='blogheading'>HERE'S WHY CONSTRUCTION COMPANIES FAIL.</p>
                                <ul>
                                    <li className='colorchange'>1. Insufficient Cash Flow</li>
                                    <li className='colorchange'>2. Charging Too Little</li>
                                    <li className='colorchange'>3. Lack Of Agreed Upon Payment Schedules</li>
                                    <li className='colorchange'>4. Insufficient Number of Profitable Sales</li>
                                    <li className='colorchange'>5. Lack of Change Order</li>
                                    <li className='colorchange'>6. Lack Of Legal Contracts</li>
                                    <li className='colorchange'>7. Excess Overhead and Employees</li>
                                    <li className='colorchange'>8. Lack of Organization, Processes & Decision Making Data</li>
                                    <li className='colorchange'>6. Summary Get-Help</li>
                                </ul>
                            </div>
                            {/* End card */}
                        </div>

                        <div className="col-lg-10 ">
                            <div className=" mt-3">
                                <p className='blogheading'>Insufficient Cash Flow</p>
                                <p className="blogpara">Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio at voluptas pariatur, rem tenetur perspiciatis, aut repellendus nesciunt placeat perferendis dolor illum qui. Asperiores id distinctio quasi soluta voluptatem earum ex voluptates nobis a qui consequatur dolor sed debitis, inventore. </p>
                                <p className='blogheading'>Charging Too Little</p>
                                <p className="blogpara">Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio at voluptas pariatur, rem tenetur perspiciatis, aut repellendus nesciunt placeat perferendis dolor illum qui. Asperiores id distinctio quasi soluta voluptatem earum ex voluptates nobis a qui consequatur dolor sed debitis, inventore, doloribus alias explicabo suscipit nesciunt maxime. Quidem vitae tempora odit in reiciendis quisquam, enim iusto molestiae numquam illo quasi.</p>
                                <p className='blogheading'>Lack Of Agreed Upon Payment Schedules</p>
                                <p className="blogpara">Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio at voluptas pariatur, rem tenetur perspiciatis, aut repellendus nesciunt placeat perferendis dolor illum qui. Asperiores id distinctio quasi soluta voluptatem earum ex voluptates nobis a qui consequatur dolor sed debitis, inventore, doloribus alias explicabo suscipit nesciunt maxime. Quidem vitae tempora odit in reiciendis quisquam, enim iusto molestiae numquam illo quasi.</p>
                                <p className='blogheading'>Lack of Change Order</p>
                                <p className="blogpara">Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio at voluptas pariatur, rem tenetur perspiciatis, aut repellendus nesciunt placeat perferendis dolor illum qui. Asperiores id distinctio quasi soluta voluptatem earum ex voluptates nobis a qui consequatur dolor sed debitis, inventore, doloribus alias explicabo suscipit nesciunt maxime. Quidem vitae tempora odit in reiciendis quisquam, enim iusto molestiae numquam illo quasi.</p>
                                <p className='blogheading'>Lack Of Legal Contracts</p>
                                <p className="blogpara">Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio at voluptas pariatur, rem tenetur perspiciatis, aut repellendus nesciunt placeat perferendis dolor illum qui. Asperiores id distinctio quasi soluta voluptatem earum ex voluptates nobis a qui consequatur dolor sed debitis, inventore, doloribus alias explicabo suscipit nesciunt maxime. Quidem vitae tempora odit in reiciendis quisquam, enim iusto molestiae numquam illo quasi.</p>
                            </div>
                            {/* End card */}
                        </div>
                        <div className="col-lg-10">
                            <div className="">
                                <p className='mx-2' style={{ display: "inline-block", fontFamily: "Poppins", fontSize: "16px", fontWeight: "700" }} >Tag</p>
                                <button className="tag bttt mx-2">Tag1</button>
                                <button className="tag bttt mx-2">Tag2</button>
                                {/* <p className="">Tags <spna className="tag">Tag1</spna> <spna className="tag">Tag2</spna></p> */}
                            </div>
                        </div>
                    </div>
                    <div className="row gy-5 justify-content-center mt-4" >
                        <div className="col-lg-10">
                            <div className="text-center">
                                <p className="dblog">Recent Blogs</p>
                                <p className="dblogses">Create Professional portraits of the highest caliber for every need, fro ma simple business headshots, content marketing and even offline collateral. </p>
                            </div>
                        </div>
                    </div>

                    <div className="row gy-5 justify-content-center mt-2">
                        <div className="col-lg-4 col-md-6">
                            <div className="pricebg h-100 ">
                                <div className=" text-center mt-3">
                                    <img src={img3} alt='' style={{ width: "90%" }} />
                                </div>
                                <div className="d-flex align-items-center justify-content-around mt-3">
                                    <div className="articlebtn">
                                        <spna className="articlebtnin">
                                            <Link className="  mx-1" to="">
                                                Product Update
                                            </Link>
                                        </spna>
                                    </div>
                                    <p> june 13,</p>
                                </div>
                                <div className="m-3">
                                    {/* <h5>Upload your selfies</h5> */}
                                    <p className="articlecard">Navigating Virtual Professional Headshots.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <div className="pricebg h-100  ">
                                <div className="text-center mt-3">
                                    <img src={img1} alt='' style={{ width: "90%" }} />
                                </div>
                                <div className="d-flex align-items-center justify-content-around mt-3">
                                    <div className="articlebtn">
                                        <spna className="articlebtnin">
                                            <Link className="  mx-1" to="">
                                                Product Update
                                            </Link>
                                        </spna>
                                    </div>
                                    <p> june 13,</p>
                                </div>
                                <div className="m-3">
                                    <p className="articlecard">professional Outdoor Headshots for a Unique Look.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="pricebg h-100  ">
                                <div className="text-center mt-3">
                                    <img src={img2} alt='' style={{ width: "90%" }} />
                                </div>
                                <div className="d-flex align-items-center justify-content-around mt-3">
                                    <div className="articlebtn">
                                        <spna className="articlebtnin">
                                            <Link className="  mx-1" to="">
                                                Product Update
                                            </Link>
                                        </spna>
                                    </div>
                                    <p> june 13,</p>
                                </div>
                                <div className="m-3">
                                    <p className="articlecard">Embracing Modern Professional Headshots: Tips for a Contemporary Look.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End container */}
            </section>

        </div>
    )
}
